/**
 * Quyền của hub — NGUỒN SỰ THẬT DUY NHẤT, trong mã.
 *
 * Seed cơ sở dữ liệu đọc từ đây, tài liệu trích từ đây. Duy trì một bảng trong tài liệu và một danh
 * sách seed riêng là đúng loại trôi lệch mà hub sinh ra để chống ở chỗ khác.
 *
 * ── Vì sao không có ký tự đại diện ───────────────────────────────────────────
 *
 * `hq.*` hay `hq.*.read` nghĩa là **mọi quyền thêm trong tương lai tự động chảy vào tay một vai** —
 * và không ai review điều đó, vì không có dòng nào thay đổi. Liệt kê tường minh thì thêm một quyền
 * là một dòng diff, đọc được trong một giây.
 */

export const HQ_PERMISSIONS = [
  "hq.audience.read",
  "hq.revenue.read",
  "hq.feedback.read",
  "hq.fleet.read",
  "hq.catalog.read",
  "hq.attention.read",
  "hq.ops.read",

  "hq.ops.run",
  "hq.feedback.note",
  "hq.attention.ack",

  "hq.staff.read",
  "hq.staff.write",
  "hq.planaxis.write",
  "hq.catalog.write",
  /**
   * Xác nhận một lượt CHUYỂN KHOẢN đã thấy tiền về — HQ-2026-002.
   *
   * Quyền RIÊNG, không gộp vào `hq.revenue.read` hay `hq.planaxis.write`. Nó là quyền duy nhất của
   * hub **cấp quyền lợi trả phí trong một app khác**: một lượt bấm biến một workspace `shop_free`
   * thành `shop_pro`. Người xem báo cáo doanh thu và người tuyên bố « tiền đã về » không nhất thiết
   * là một, và không nên là một.
   */
  "hq.billing.confirm",
  /** Xem chế độ khai của Bube Bank Transfer Hub bube-banktransfer — HQ-2026-003. */
  "hq.banktransfer.read",
  /**
   * Đổi chế độ khai của Bube Bank Transfer Hub (thoáng / chặt) — HQ-2026-003.
   *
   * Quyền RIÊNG, vai CHỦ: chuyển sang « thoáng » là chấp nhận một rủi ro bảo mật cho MỌI khách của bube-banktransfer
   * (kẻ gian khai trước số tài khoản của cửa hàng khác thì thấy được tin tiền về của họ cho tới khi chủ thật xác
   * minh — ADR-010 D9 bên đó). Xem được không có nghĩa là nên đổi được.
   */
  "hq.banktransfer.write",
  /**
   * Tải APK NỘI BỘ « Bube Bank Transfer Hub » của bube-banktransfer — HQ-2026-003, người dùng chốt 2026-10-13: chỉ
   * DEV tải, trong hub; dashboard của khách không có đường nào tới bản này. Hub chưa có vai « dev » ⇒ để vai CHỦ;
   * mở cho vai khác là một dòng diff ở danh sách vai.
   */
  "hq.banktransfer.hubapk",
  /** Xem đối tác tích hợp của từng app + thông số — HQ-2026-005. */
  "hq.integrations.read",
  /**
   * Bật / tắt một đối tác tích hợp cho TOÀN NỀN TẢNG của một app — HQ-2026-005.
   *
   * Quyền RIÊNG, vai CHỦ: tắt SePay là cắt tin tiền về của MỌI khách bube-banktransfer đang dùng SePay; tắt
   * MISA là mọi cửa hàng phát hành hoá đơn qua MISA dừng lại. Xem được không có nghĩa là nên tắt được.
   */
  "hq.integrations.write",
  /**
   * PLAT-2026-141 · ADR-041 D5 — xem PHÒNG THỬ (L1): fixture (danh tính thử của Bube — chỉ ô không bí mật + gợi ý che), lượt
   * thử. Quyền RIÊNG, tách khỏi tích hợp nền tảng (L2): ai xem / sửa kết nối của app không mặc nhiên có tài khoản thử, và ngược
   * lại. Vai CHỦ; mở cho vai khác là một dòng diff ở danh sách vai.
   */
  "hq.lab.read",
  /** Tạo / sửa / tắt / xoá fixture phòng thử, có audit (chỉ tên ô). Vai CHỦ. */
  "hq.lab.write",
  /**
   * Xem danh sách workspace / user của từng app (email, tên, gói) — PLAT-2026-114.
   *
   * Vai VẬN HÀNH + CHỦ, KHÔNG vai chỉ đọc (người dùng chốt 2026-10-15): màn này hiện dữ liệu cá nhân của khách, khác mọi
   * màn số liệu khác của hub vốn chỉ có số đếm.
   */
  "hq.customers.read",
  /**
   * Cho dùng thử / cấp gói không thu tiền / thu hồi gói — PLAT-2026-114.
   *
   * Quyền RIÊNG, vai CHỦ, tách khỏi `hq.billing.confirm`: xác nhận chuyển khoản cần một lượt thu CÓ SẴN, còn quyền này
   * cấp gói trả phí mà không có đồng nào. App áp trần (90 ngày / 12 tháng) và không cho chạm khách đang trả tiền.
   */
  "hq.plans.override",
  /**
   * Xem hộp thư hỗ trợ + chi tiết ticket của mọi app (tên, email khách, nội dung) — PLAT-2026-115 · ADR-033 Đ6.
   * Vai VẬN HÀNH + CHỦ; vai chỉ đọc KHÔNG có (dữ liệu cá nhân, như `hq.customers.read`).
   */
  "hq.support.read",
  /** Trả lời khách, đổi trạng thái / ưu tiên ticket, ghi chú nội bộ — PLAT-2026-115. Tin đi sang app dưới tên nhân viên. */
  "hq.support.reply",
  /** Giao / nhận ticket — PLAT-2026-115. Tách khỏi `reply` để sau này có vai « trưởng ca » chỉ phân việc. */
  "hq.support.assign",
  /**
   * Xem sổ lượt hoá đơn Bube của khách (số dư, sổ, chính sách) — PLAT-2026-156 · ADR-049. Vai VẬN HÀNH + CHỦ: màn tìm khách theo
   * tên / MST nên cùng nhóm với `hq.customers.read`; vai chỉ đọc KHÔNG có.
   */
  "hq.invoicequota.read",
  /** Xem tình trạng máy chủ lấy hóa đơn Việt Nam (lỗi, hàng chờ, thông số chạy) — PLAT-2026-173. Chỉ đọc; vai VẬN HÀNH + CHỦ. */
  "hq.acquisition.read",
  /**
   * Cấp thêm lượt hoá đơn cho một phạm vi — PLAT-2026-156. Quyền RIÊNG, vai CHỦ: một lượt bấm cho khách quyền phát hành thêm hoá
   * đơn (cùng mức nhạy cảm với `hq.plans.override`). Hạ xuống vai vận hành là MỘT dòng diff ở `OPERATOR`.
   */
  "hq.invoicequota.grant",
  /** Đảo / bù một khoản cấp (bút toán ngược có lý do) — PLAT-2026-156. Tách khỏi `grant`: sửa sai không mặc nhiên là quyền cấp. Vai CHỦ. */
  "hq.invoicequota.adjust",
  /** Đổi chính sách phạm vi (sổ Bube / nhà tự quản / cưỡng chế) — PLAT-2026-156. Vai CHỦ: bật `enforced` chặn phát hành khi hết lượt. */
  "hq.invoicequota.policy",
  /**
   * Ghi nhận / yêu cầu ĐÁP ỨNG ĐỐI TÁC của một khoản cấp (đã cấp ở dashboard · gửi qua Agency Core) — PLAT-2026-156 G4. Quyền
   * RIÊNG, vai CHỦ: gọi API đại lý là thao tác ra ngoài (có thể tốn tiền với nhà); không đổi quyền Bube đã cấp.
   */
  "hq.invoicequota.fulfill",
] as const;

export type HqPermission = (typeof HQ_PERMISSIONS)[number];

export const HQ_ROLES = ["hq.viewer", "hq.operator", "hq.owner"] as const;
export type HqRole = (typeof HQ_ROLES)[number];

const VIEWER = [
  "hq.audience.read",
  "hq.revenue.read",
  "hq.feedback.read",
  "hq.fleet.read",
  "hq.catalog.read",
  "hq.attention.read",
  "hq.banktransfer.read",
  "hq.integrations.read",
] as const satisfies readonly HqPermission[];

const OPERATOR = [
  ...VIEWER,
  "hq.ops.read",
  "hq.ops.run",
  "hq.feedback.note",
  "hq.attention.ack",
  "hq.customers.read",
  "hq.support.read",
  "hq.support.reply",
  "hq.support.assign",
  "hq.invoicequota.read",
  "hq.acquisition.read",
] as const satisfies readonly HqPermission[];

export const HQ_ROLE_PERMISSIONS: Readonly<Record<HqRole, readonly HqPermission[]>> = {
  "hq.viewer": VIEWER,
  "hq.operator": OPERATOR,
  "hq.owner": HQ_PERMISSIONS,
};

/** Nhãn tiếng Việt cho giao diện quản trị. */
export const HQ_ROLE_LABEL: Readonly<Record<HqRole, string>> = {
  "hq.viewer": "Chỉ đọc",
  "hq.operator": "Vận hành",
  "hq.owner": "Chủ",
};

/**
 * Các quyền dưới đây CHỈ vai chủ có. Khai tường minh để một lần « tiện tay » thêm vào vai vận hành
 * là một dòng diff nhìn thấy được, chứ không phải một hệ quả của phép toán tập hợp.
 */
export const OWNER_ONLY_PERMISSIONS = [
  "hq.staff.read",
  "hq.staff.write",
  "hq.planaxis.write",
  "hq.catalog.write",
  /**
   * ⚠️ `hq.billing.confirm` để ở vai CHỦ, và đây là một đánh đổi chứ không phải một kết luận.
   *
   * Người ngồi canh sao kê hằng ngày thường là vận hành, không phải chủ — nên để ở đây làm việc đó
   * bất tiện. Đổi lại: ai có quyền này có thể gõ một mã thu tiền bất kỳ và tuyên bố đã nhận đủ
   * tiền, và bube-shop sẽ tin (nó tin CHỮ KÝ của hub, không tin con số). Tiền vào **một tài khoản
   * cá nhân** (`payment-bank.ts`), tức người đối chiếu được sao kê hiện cũng chính là chủ.
   *
   * Hạ xuống vai vận hành là MỘT DÒNG diff ở `OPERATOR` — cố ý để nó là một dòng nhìn thấy được,
   * đúng tinh thần « không ký tự đại diện » của file này.
   */
  "hq.billing.confirm",
  "hq.banktransfer.write",
  "hq.banktransfer.hubapk",
  "hq.integrations.write",
  "hq.lab.read",
  "hq.lab.write",
  "hq.plans.override",
  "hq.invoicequota.grant",
  "hq.invoicequota.adjust",
  "hq.invoicequota.policy",
  "hq.invoicequota.fulfill",
] as const satisfies readonly HqPermission[];

/** Quyền hiệu lực của một vai. Một chỗ duy nhất suy ra, để guard và API không đọc hai bảng. */
export const permissionsOfRole = (role: HqRole): readonly HqPermission[] => HQ_ROLE_PERMISSIONS[role];
